import { defineComponent } from "vue";
import handleClipboard from "@/utils/clipboard";
import imageNotFound from "@com/assets/default_small.png";
import { getPlatformInfo, getProductType } from "@pt/views/pt-entry/common-setting/promote-product/promote-product";
import { ProductType } from "@pt/enums/product";
export default defineComponent({
    props: {
        product: {
            type: Object,
            required: true
        }
    },
    setup: function setup() {
        var copyLink = function copyLink(id) {
            handleClipboard(id, {
                target: ".copy-link",
                delegateTarget: document.querySelector("#clipboardElement")
            });
        };
        return {
            imageNotFound: imageNotFound,
            ProductType: ProductType,
            handleClipboard: handleClipboard,
            copyLink: copyLink,
            getPlatformInfo: getPlatformInfo,
            getProductType: getProductType
        };
    }
});
